import G6 from '@antv/g6'
import addLine from './add-edge'

const behaviors = {
  'add-edge':addLine,
}

export function initBehaviors() {
  for (let key in behaviors) {
    G6.registerBehavior(key,behaviors[key])
  }
}



// WEBPACK FOOTER //
// ./src/components/flow/components/behavior/index.js